import React, { useState, useEffect, useRef } from "react";
import { useDispatch, shallowEqual, useSelector } from "react-redux";
import * as actions from "../../../_redux/occupation-categories/OccupationCategoriesAction";
import { redirectToPages, resultAlert } from "../../../../../../_helpers/Helpers";
import { 
  Card,
  CardBody,
  CardFooter,
  CardHeader,
  ModalProgressBar
} from "../../../../../../_metronic/_partials/controls";
import { OccupationCategoryEditForm } from "./OccupationCategoryEditForm";

export function OccupationCategoryEdit({
  history,
  match: {
    params: { id }
  }
}) {
  const [title, setTitle] = useState("");
  const dispatch = useDispatch();
  const { actionsLoading, isSuccess, type, category } = useSelector(
    (state) => ({
      actionsLoading: state.occupationCategories.actionsLoading,
      isSuccess: state.occupationCategories.isSuccess,
      type: state.occupationCategories.type,
      category: state.occupationCategories.category
    }),
    shallowEqual
  );

  useEffect(() => {
    dispatch(actions.getCategory(id));
    return () => dispatch(actions.cleanCategoriesState());
  }, [id, dispatch]);
  
  useEffect(() => {
    let _title = "Meslek Kategorisi";
    let action = id ? "Düzenle" : "Ekle";
    _title += " " + action;
    setTitle(_title);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  // Belli Bir Meslek Kategorisini Kaydeder
  const saveCategory = (values) => {
    dispatch(actions.saveCategory(values)).then((result) => onResult(result));
  };
  
  const onResult = ({ isSuccess, type, message }) => {
    resultAlert(type, message);
    if (isSuccess) setTimeout(() => history.push(`/meslek-kategorileri`), 2500);
  };

  const btnRef = useRef();  
  const saveCategoryClick = () => {
    if (btnRef && btnRef.current) {
      btnRef.current.click();
    }
  };

  // Yetki ve Hata Kontrolleri
  if (isSuccess === false) return redirectToPages(type);
  
  return (
    <Card>
      {actionsLoading && <ModalProgressBar />}
      <CardHeader title={title} />
      <CardBody>
        <div className="mt-5">          
          <OccupationCategoryEditForm 
            category={category}
            btnRef={btnRef} 
            saveCategory={saveCategory}
          />
        </div>        
      </CardBody>
      <CardFooter>
        <div className="offset-sm-2">          
          <button
            type="submit"
            className="btn btn-primary"
            onClick={saveCategoryClick}
          >
            Kaydet
          </button>          
        </div>
      </CardFooter>
    </Card>
  );
}